import React from 'react'
import { Card } from '@/components/ui/card'
import { Button } from '@/components/ui/button'
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select'
import { ArrowRight, Volume2, ArrowLeft, SkipForward } from 'lucide-react'

interface VoiceSettingsProps {
  onNext: () => void
  onPrevious: () => void
  onSkip: () => void
}

interface Voice {
  id: string
  name: string
  description: string
}

const VoiceSettings = ({ onNext, onPrevious, onSkip }: VoiceSettingsProps) => {
  const [voice, setVoice] = React.useState('female1')

  const voices: Voice[] = [
    { id: 'female1', name: '女声1', description: '温柔的女声' },
    { id: 'female2', name: '女声2', description: '活泼的女声' },
    { id: 'male1', name: '男声1', description: '浑厚的男声' },
    { id: 'male2', name: '男声2', description: '儿童男声' },
  ]

  return (
    <div className="w-full">
      <Card className="p-8">
        <div className="max-w-3xl mx-auto">
          <h2 className="text-xl font-bold text-gray-800 mb-2">配音设置</h2>
          <p className="text-sm text-gray-500 mb-8">
            为你的绘本选择合适的配音声音。
          </p>

          <div className="space-y-8">
            <div className="space-y-3">
              <label className="block text-sm font-medium text-gray-700">
                选择配音声音
              </label>
              <select 
                className="w-full h-10 pl-4 pr-10 text-sm rounded-lg border border-gray-200 
                           focus:border-primary/20 focus:ring-2 focus:ring-primary/20 
                           bg-white appearance-none cursor-pointer
                           hover:border-primary/20 transition-colors"
                style={{
                  backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='%23666' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolyline points='6 9 12 15 18 9'%3E%3C/polyline%3E%3C/svg%3E")`,
                  backgroundRepeat: 'no-repeat',
                  backgroundPosition: 'right 0.5rem center',
                  backgroundSize: '1rem'
                }}
              >
                <option value="">请选择配音</option>
                {voices.map((v) => (
                  <option key={v.id} value={v.id}>
                    {v.name}
                  </option>
                ))}
              </select>
            </div>

            <div className="bg-primary/5 p-4 rounded-xl">
              <div className="flex items-center justify-between">
                <div>
                  <h3 className="text-sm font-medium text-gray-800 mb-1">试听示例</h3>
                  <p className="text-xs text-gray-500">
                    "小兔子蹦蹦跳跳地穿过森林，遇见了可爱的小松鼠..."
                  </p>
                </div>
                <Button
                  variant="outline"
                  size="sm"
                  className="flex items-center gap-2"
                  onClick={() => {/* 试听逻辑 */}}
                >
                  <Volume2 className="w-4 h-4" />
                  <span>试听</span>
                </Button>
              </div>
            </div>
          </div>

          <div className="flex justify-between items-center mt-10">
            <Button
              variant="outline"
              onClick={onPrevious}
              className="flex items-center gap-2"
            >
              <ArrowLeft className="w-4 h-4" />
              <span>上一步</span>
            </Button>

            <div className="flex items-center gap-3">
              <Button
                variant="ghost"
                onClick={onSkip}
                className="text-gray-500 hover:text-gray-700 flex items-center gap-2"
              >
                <SkipForward className="w-4 h-4" />
                <span>跳过配音</span>
              </Button>
              <Button
                onClick={onNext}
                className="flex items-center gap-2 bg-gradient-to-r from-primary via-accent to-secondary hover:opacity-90"
              >
                <span>下一步</span>
                <ArrowRight className="w-4 h-4" />
              </Button>
            </div>
          </div>
        </div>
      </Card>
    </div>
  )
}

export default VoiceSettings 